export default function MyProfile() {
  myProfileInit();
};

function myProfileInit() {
  const editButton = document.querySelector(".js-my-profile__edit-style-button");
  const editStyle = document.querySelector(".js-my-profile__edit-style-wrapper");
  const resultStyle = document.querySelector(".js-my-profile__style-wrapper");

  const handleClick = () => {
    if (editStyle && resultStyle) {
      editStyle.style.display = "flex";
      resultStyle.style.display = "none";
    }
  };

  if (editButton) {
    editButton.addEventListener("click", handleClick);
  }

  const radioList = document.querySelectorAll(".my-profile__input-radio");

  if (radioList.length > 0) {
    radioList.forEach((radio) => {
      if (radio) {
        const radioId = radio.getAttribute("value");
        const checkbox = document.getElementById(`item_${radioId}`);
        if (checkbox) {
          radio.addEventListener("change", () => {
            checkbox.checked = true;
          });
        }
      }
    });
  }

}
